import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/productdetail.css";
import "../styles/PurchaseOptions.css";
import {
  AddItemToCart,
  AddItemToWishList,
  getCartItems,
  getProductQty,
} from "../services/Cart.jsx";
import { Helmet } from "react-helmet-async";
import { getRatings } from "../services/apiService";
import { showSnackbar } from "../comopnents/snackbar.jsx";
import { Notifyed } from "../services/Auth.jsx";
import { Rate, Button } from "antd";
import { CartContext } from "../contextApi/CartContext";
import { withImageVersion } from "../contextApi/ImageVersionContext";
import ProductSpares from "../comopnents/ProductSpares.jsx";
import SimilarProducts from "../comopnents/RelatedProducts.jsx";
import PincodeChecker from "../comopnents/PinCode.jsx";
import Coupons from "../comopnents/Coupons.jsx";
import { getWallet } from "../services/Spares";
import AuthModal from "../comopnents/AuthModal.jsx";
import { getProductById } from "../services/apiService.js";
import AddRecentlyViewed from "../comopnents/AddRecentlyViewed.jsx";
import noimage from "../assets/noimage.webp";
import { MdLocalShipping } from "react-icons/md";
import { FaRegClock } from "react-icons/fa6";
import { Spin } from "antd";
import FullScreenLoader from "../comopnents/FullScreenLoader.jsx";
import { InnerImageZoom } from "react-inner-image-zoom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaStar } from "react-icons/fa";
import CartQuantityControl from "../comopnents/CartQuantityControl.jsx";
import {
  buildCartPurchaseData,
  getQuantityOptions,
  getApplicableCoupon,
  getApplicableExtraDiscount,
  getQuantityStep,
  getSavedCartPurchaseData,
} from "../utils/purchaseOptions.js";
import { isOutOfStock } from "../utils/stock.js";
import { getCouponTypeLabel } from "../utils/couponTypes.js";

import "react-inner-image-zoom/lib/styles.min.css";

const ProductPage = () => {
  const isLoggedIn = Boolean(localStorage.getItem("token"));
  const navigate = useNavigate();
  const location = useLocation();
  const { addToCart, itemList, setCartQty } = useContext(CartContext);
  const productTopRef = useRef(null); // Reference for scrolling to top
  const [loginOpen, setLoginOpen] = useState(false);
  const [pendingCartId, setPendingCartId] = useState(null); 
  const [zoom, setZoom] = useState(false);
  const [loading, setLoading] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const productid = searchParams.get("productid");

  const [product, setProduct] = useState([]);

  const [ratings, setRatings] = useState([]);
  const [comments, setComments] = useState([]);
  const [mainImage, setMainImage] = useState(null);
  const [showSpecImage, setShowSpecImage] = useState(false);
  const [qty, setqty] = useState(product.minorderqty || 1);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [imgSrc, setImgSrc] = useState(null);
  // const [isVideo, setIsVideo] = useState(false);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [showFullDesc, setShowFullDesc] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [wallet, setWallet] = useState([]);
  const [openCoupons, setOpenCoupons] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [selectedPurchaseType, setSelectedPurchaseType] = useState("piece");
  const cartQty =
    itemList.find((item) => String(item.productId) === String(productid))
      ?.count || 0;
  const savedPurchaseData = getSavedCartPurchaseData(productid);
  const activePurchaseType =
    cartQty > 0
      ? savedPurchaseData?.purchaseType || "piece"
      : selectedPurchaseType;

  const visibleComments = showAll ? comments : comments;

  const walletamount = async () => {
    try {
      const response = await getWallet();
      setWallet(response.data);
      console.log("walletresponse:", response.data);
    } catch (error) {
      console.log("wallet error:", error);
    }
  };
  const isVideo = (url) => /\.(mp4|webm|ogg|mov)$/i.test(url);

  useEffect(() => {
    let isMounted = true;

    if (!mainImage) {
      setImgSrc(noimage);
      return;
    }

    // ✅ STEP 1: If video → directly set
    if (isVideo(mainImage)) {
      setImgSrc(mainImage);
      return;
    }

    // ✅ STEP 2: Only validate images
    const img = new Image();
    img.src = mainImage;

    img.onload = () => {
      if (isMounted) setImgSrc(mainImage);
    };

    img.onerror = () => {
      if (isMounted) setImgSrc(noimage);
    };

    return () => {
      isMounted = false;
    };
  }, [mainImage]);

  useEffect(() => {
    if (!productid) return;

    loadRatings(productid);

    if (localStorage.getItem("token")) {
      walletamount();
    }
  }, [productid]);

  useEffect(() => {
    if (product?.minorderqty) {
      if (cartQty > 0) {
        // Use current cart quantity as the source of truth
        setqty(cartQty);
        // purchase type can be restored if needed, but coupon will be derived from qty
        const savedData = getSavedCartPurchaseData(productid);
        if (savedData?.purchaseType) {
          setSelectedPurchaseType(savedData.purchaseType);
        }
        return;
      }

      // No cart quantity – fall back to defaults
      setqty(Number(product.minorderqty));
      setSelectedCoupon(null);
      setSelectedPurchaseType("piece");
    }
  }, [product, productid, cartQty]);

  useEffect(() => {
    if (cartQty > 0) {
      setqty(cartQty);
    }
  }, [cartQty]);

  useEffect(() => {
    if (!cartQty && !selectedCoupon) {
      setqty(buildCartPurchaseData(product, selectedPurchaseType).quantity);
    }
  }, [cartQty, product, selectedPurchaseType, selectedCoupon]);

  useEffect(() => {
    if (!product?.minorderqty) return;
    setSelectedCoupon(
      product.Qtydiscounts?.length
        ? getApplicableCoupon(Number(qty), product.Qtydiscounts)
        : getApplicableExtraDiscount(Number(qty), product.discount_items || []),
    );
  }, [qty, product]);
  // Function to scroll to product top
  const scrollToProductTop = () => {
    if (productTopRef.current) {
      productTopRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  /* 🔹 LOAD PRODUCT DETAILS */
  useEffect(() => {
    if (!productid) return;
    setLoading(true);
    getProductById(productid)
      .then((res) => {
        const p = { ...res.data[0], qty: 0 };
        setProduct(p);
        setMainImage(withImageVersion(p.image1));

        // Scroll to top when product loads
        setTimeout(scrollToProductTop, 100);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching product:", err);
        setLoading(false);
      });
  }, [productid]);

  const loadRatings = async (id) => {
    try {
      const res = await getRatings(id);

      setRatings(res?.rating || []);
      setComments(res?.comments || []);
    } catch (e) {
      console.error("Error loading ratings:", e);
    }
  };
  const stripHtml = (html) => {
    if (!html) return "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const cleanDescription = stripHtml(product.description || "");

  const MAX_LENGTH = 250;
  const isLong = cleanDescription.length > MAX_LENGTH;

  const getTruncatedHtml = (html, maxLength) => {
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const textContent = tempDiv.textContent || tempDiv.innerText || "";

    if (textContent.length <= maxLength) return html;

    let truncatedText = textContent.substring(0, maxLength);
    const lastSpaceIndex = truncatedText.lastIndexOf(" ");
    if (lastSpaceIndex > 0) {
      truncatedText = truncatedText.substring(0, lastSpaceIndex);
    }

    return truncatedText;
  };

  const handleNotify = async (productid) => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      setShowAuthModal(true);
      return;
    }
    try {
      const response = await Notifyed({
        customerid: userId,
        productid: productid,
      });
      showSnackbar("success", "you will be notified when stock is available!");
      console.log("notify me:", response);
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  const handleLoginSuccess = async () => {
    if (pendingCartId) {
      const userId = localStorage.getItem("userId");
      if (userId) {
        if (isOutOfStock(product)) {
          await handleNotify(pendingCartId.productId || pendingCartId);
          setPendingCartId(null);
          return;
        }

        try {
          const payload = {
            customerid: userId,
            productid: pendingCartId,
            qty: 1,
            stock: product.stock,
          };

          await AddItemToCart(payload);

          // setProducts((prev) =>
          //   prev.map((p) =>
          //     p.productid === pendingCartId ? { ...p, qty: 1 } : p,
          //   ),
          // );
        } catch (error) {
          console.error("Add to cart after login error:", error);
        }
      }
    }
    setPendingCartId(null);
  };
  const totalCount = ratings.reduce(
    (sum, r) => sum + (Number(r.zcount) || 0),
    0,
  );
  const weightedSum = ratings.reduce(
    (sum, r) => sum + (Number(r.rating) || 0) * (Number(r.zcount) || 0),
    0,
  );
  const avgRating = totalCount ? weightedSum / totalCount : 0;

  const handleAddToCart = async (
    productId,
    purchaseType = selectedPurchaseType,
  ) => {
    const userId = localStorage.getItem("userId");
    if (isOutOfStock(product)) {
      await handleNotify(productId);
      return;
    }

    const slab = product.Qtydiscounts?.length
      ? getApplicableCoupon(qty, product.Qtydiscounts)
      : getApplicableExtraDiscount(qty, product.discount_items || []);
    const extraDiscount = slab ? Number(slab.discount) : 0;
    const productDiscount = Number(product.discount || 0);
    const totalDiscount = productDiscount + extraDiscount;
    const minimumCouponQty = slab
      ? Number(slab.fromqty ?? slab.qty)
      : qty;

    const slabTypeToPurchase = {
      piece: "piece",
      pack: "pack",
      cart: "carton",
      extra1: "extra1",
      extra2: "extra2",
      extra3: "extra3",
    };
    let resolvedPurchaseType = slabTypeToPurchase[slab?.type] || purchaseType;

    const purchaseData = buildCartPurchaseData(product, resolvedPurchaseType);

    const couponTitle = slab
      ? Number(slab.discount) > 0
        ? `BUY ${slab.fromqty ?? slab.qty}+ Get ${slab.discount}% + ${productDiscount}% Discount`
        : `BUY ${slab.fromqty ?? slab.qty} Get ${productDiscount}% Discount`
      : undefined;

    const enhancedPurchaseData = {
      ...purchaseData,
      purchaseType: resolvedPurchaseType,
      quantity: Number(qty),
      appliedCouponQty: minimumCouponQty,
      productDiscount,
      extraDiscount,
      totalDiscount,
      couponSelected: !!slab,
      minimumCouponQty,
      couponTitle,
      Qtydiscounts: product.Qtydiscounts || [],
      discount_items: product.discount_items || [],
      mrp: Number(product.mrp || 0),
    };

    if (!userId) {
      setPendingCartId({ productId, purchaseType: resolvedPurchaseType });
      setShowAuthModal(true);
      return;
    }

    try {
      const payload = {
        customerid: userId,
        productid: productId,
        qty: Number(qty),
        stock: product.stock,
      };

      await AddItemToCart(payload);
      addToCart(productId, Number(qty), enhancedPurchaseData);

      showSnackbar("success", "Item added to cart!");
    } catch (error) {
      console.error(
        "Add to cart error:",
        error.response?.data || error.message,
      );
      showSnackbar("error", "Failed to add item to cart!");
    }
  };

  const handleCartQtyChange = async (newQty) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setPendingCartId({ productId: product.productid, qty: newQty });
      setShowAuthModal(true);
      return;
    }

    try {
      await getProductQty({
        user_id: userId,
        productid: product.productid,
        qty: newQty,
      });
      setCartQty(product.productid, newQty);
      setqty(newQty);
    } catch (error) {
      console.error("Update cart qty error:", error?.message || error);
      showSnackbar("error", "Failed to update quantity!");
    }
  };

  const handleAuthSuccess = () => {
    setShowAuthModal(false);
    if (pendingCartId) {
      handleAddToCart(pendingCartId.productId, pendingCartId.purchaseType);
      setPendingCartId(null);
    }
  };
  const getRatingText = (rating) => {
    if (rating >= 4.5) return "Excellent";
    if (rating >= 4) return "Very Good";
    if (rating >= 3) return "Good";
    if (rating >= 2) return "Average";
    return "Poor";
  };

  const AddToWishList = async (productid) => {
    try {
      const userId = localStorage.getItem("userId");

      if (!userId) {
        setPendingCartId(productid);
        setShowAuthModal(true);
        return;
      }

      const response = await AddItemToWishList({
        productid,
        customerid: userId,
      });

      const message = response?.data?.data || response?.data;

      if (message === "added to wishlist") {
        setWishlistItems((prev = []) => [...prev, productid]);
        showSnackbar("success", "Added to wishlist!");
      } else if (message === "already in wishlist") {
        showSnackbar("info", "Item already in wishlist!");
      } else {
        showSnackbar("error", "Something went wrong!");
      }
    } catch (error) {
      console.error("Wishlist error:", error.response?.data || error.message);
      showSnackbar("error", "Failed to add to wishlist!");
    }
  };

  // if (!product) return <p>Loading...</p>;
  const images = [
    withImageVersion(product.image1),
    withImageVersion(product.image2),
    withImageVersion(product.image3),
    withImageVersion(product.image4),
    withImageVersion(product.exploreimage),
    product.video,
  ].filter(Boolean);

  const getFinalPrice = (product, selectedQty, extraDiscount) => {
    const mrp = Number(product.mrp) || 0;
    const slab = product.Qtydiscounts?.length
      ? getApplicableCoupon(selectedQty, product.Qtydiscounts)
      : getApplicableExtraDiscount(selectedQty, product.discount_items || []);
    const productDiscount = Number(product.discount || 0);
    const couponDiscount =
      extraDiscount !== undefined
        ? Number(extraDiscount)
        : Number(slab?.discount || 0);
    const basePrice = mrp - (mrp * productDiscount) / 100;
    const price = basePrice - (basePrice * couponDiscount) / 100;
    return price.toFixed(2);
  };
  console.log("coommetts", visibleComments);
  return (
    <div className="product-detail-outer" style={styles.container}>
      <Helmet>
        <title>{product.displaymodelno?.toUpperCase()}</title>

        <meta name="description" content={product.description} />

        <meta name="keywords" content={product.keywords} />

        <meta property="og:title" content={product.displaymodelno} />
        <meta property="og:description" content={product.description} />
        <meta property="og:image" content={product.image1} />
      </Helmet>
      <div className="container" ref={productTopRef}>
        <FullScreenLoader loading={loading} />

        <div className="product-wrapper">
          {/* LEFT: IMAGES (60%) */}
          <div>
            <div className="container">
              <div className="product-images">
                <div className="thumbs">
                  {images.map((item, index) => {
                    const video = isVideo(item);

                    return video ? (
                      <video
                        key={index}
                        src={item}
                        className={`thumb-video ${item === mainImage ? "active-thumb" : ""
                          }`}
                        onClick={() => setMainImage(item)}
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        onMouseEnter={(e) => e.target.play()}
                        onMouseLeave={(e) => e.target.pause()}
                      />
                    ) : (
                      <img
                        key={index}
                        src={item}
                        className={`thumb-img ${item === mainImage ? "active-thumb" : ""
                          }`}
                        onClick={() => setMainImage(item)}
                        loading="lazy"
                        alt="thumb"
                      />
                    );
                  })}
                </div>

                {/* MAIN IMAGE */}
                <div
                  className="main-img-wrapper"
                  style={{ border: "1px solid #e2e2e2" }}
                >
                  {!imgSrc ? (
                    <div className="image-skeleton" />
                  ) : isVideo(imgSrc) ? (
                    <video
                      className="main-img"
                      controls
                      muted
                      playsInline
                      autoPlay
                      preload="metadata"
                    >
                      <source src={imgSrc} type="video/mp4" />
                    </video>
                  ) : (
                    <InnerImageZoom
                      src={imgSrc}
                      zoomSrc={imgSrc}
                      zoomType="hover"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="product-extra product-extra-row">
              {/* SPECIFICATIONS */}
              {product.spe && product.spe.length > 0 && (
                <div className="specifications-card">
                  <h3 style={{ marginBottom: 15 }}>Specifications</h3>

                  <div className="spec-grid">
                    {product.spe.map((item, index) => (
                      <div key={index} className="spec-item">
                        <strong>{item.skey}</strong>
                        <span>{item.value}</span>
                      </div>
                    ))}
                  </div>

                  {product?.spec_image && product.spec_image.trim() !== "" && (
                    <button
                      onClick={() => navigate("/dealer-form")}
                      style={{
                        marginTop: "15px",
                        border: "none",
                        background: "#005487",
                        color: "#fff",
                        padding: "10px 16px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Read More
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="background">
            <div className="product-info">
              <div className="product-info-container">
                <div>
                  <h1>
                    <span>{product.modelno}  </span>
                    {product.mainmodelno && product.mainmodelno !== "--"
                      ? "-" + " " + product.mainmodelno
                      : ""}{" "}
                  </h1>
                  {product.partno != 0 && (
                    <h3>Part No: {product.partno}</h3>
                  )}
                  <h3>{product.subcategory}</h3>

                  <h3>{product.brand}</h3>

                  <span style={{ color: "black" }}>{product.category}</span>

                  {ratings.length > 0 && (
                    <div>
                      <span className="rating-row">
                        <FaStar color="gold" size={24} />

                        <span>{getRatingText(avgRating)}</span>

                        <span className="rating-badge">
                          {avgRating.toFixed(1)}
                        </span>

                        <span style={{ margin: 0 }}>
                          (Ratings {totalCount})
                        </span>
                      </span>
                    </div>
                  )}

                  {/* FIXED: Description with HTML rendering */}
                  <div
                    className={`desc-container ${showFullDesc ? "desc-expanded" : ""}`}
                  >
                    {showFullDesc ? (
                      // Show full HTML content when expanded
                      <div
                        className="desc-html-content"
                        style={{ color: "black" }}
                        dangerouslySetInnerHTML={{
                          __html: product.description || "",
                        }}
                      />
                    ) : (
                      // Show truncated text preview with ellipsis
                      <div className="desc-preview">
                        <div
                          className="desc-html-preview"
                          style={{ color: "#5a5454" }}
                          dangerouslySetInnerHTML={{
                            __html: getTruncatedHtml(
                              product.description || "",
                              MAX_LENGTH,
                            ),
                          }}
                        />
                        {isLong && <span className="desc-ellipsis">...</span>}
                      </div>
                    )}
                  </div>

                  {isLong && (
                    <span
                      onClick={() => setShowFullDesc(!showFullDesc)}
                      className="read-more-btn"
                    >
                      {showFullDesc ? " Read less" : " Read more"}
                    </span>
                  )}

                  <div
                    className="price-section price-section-row"
                  >
                    <div
                      className="price-row"
                      style={{
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      {Number(product.mrp || 0) <= 0 &&
                        Number(product.netrate || 0) <= 0 ? (
                        <span className="new1">
                          Coming Soon
                        </span>
                      ) : (
                        <>
                          {/* Price */}
                          {Number(product.netrate || 0) > 0 ? (
                            <span className="new1">
                              Price : ₹{Number(product.netrate).toFixed(2)}
                            </span>
                          ) : (
                            <span className="new1">
                              Price : ₹
                              {getFinalPrice(
                                product,
                                qty,
                                selectedCoupon ? selectedCoupon.discount : 0
                              )}
                            </span>
                          )}

                          {/* MRP */}
                          {Number(product.mrp || 0) > 0 && (
                            <span className="mrpP">
                              M.R.P :{" "}
                              <span className="old2">
                                ₹{Number(product.mrp).toFixed(2)}
                              </span>
                            </span>
                          )}

                          {/* Discount */}
                          {Number(product.discount) > 0 && (
                            <span className="discount-badge1">
                              {Number(product.discount)}% OFF
                            </span>
                          )}
                        </>
                      )}
                    </div>


                    {/* <CartQuantityControl
                      qty={qty}
                      minQty={product.minorderqty}
                      stock={product.stock}
                      onChange={cartQty > 0 ? handleCartQtyChange : setqty}
                      className="qty-button"
                    /> */}
                  </div>
                  {/* {(product.discount || product.discount_items?.length) && (
                    <span className="discount-badge1">
                      {product.discount}% OFF
                    </span>
                  )} */}
                </div>
              </div>
             {isLoggedIn && <small>Min order Qty : {product.minorderqty}</small>}

              {product?.free_items?.length > 0 && (
                <div
                  className="free-items-box"
                  style={{
                    border: "1px solid rgb(230, 223, 223)",
                    padding: "11px 10px",
                    borderRadius: "10px",
                    background: "white",
                  }}
                >
                  <div className="free-items-inner">
                    <h6 className="free-items-heading" style={{ color: "#005487", marginBottom: 15 }}>
                      🎁 Order {product.free_items[0]?.minqty} pieces to get
                      Free Product
                    </h6>

                    {product.free_items.map((item, index) => (
                      <div
                        key={index}
                        className="free-item-row"
                      >
                        <img
                          onClick={() =>
                            navigate(
                              `/productdetail?productid=${item.feeproductid}`,
                            )
                          }
                          src={withImageVersion(item.image)}
                          alt={item.product_name}
                        />

                        <div className="free-item-text">
                          <h5>
                            {item.product_name} {" (" + item.category + ")"}
                          </h5>

                          <h6>
                            Qty : {item.qty} &nbsp;&nbsp; M.R.P: ₹
                            {Number(item.price || 0).toFixed(2)}
                          </h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="bulk-grid">
                {(product.Qtydiscounts || []).map((slab, index) => {
                  const item =
                    product.discount_items?.find(
                      (discountItem) =>
                        Number(discountItem.qty) === Number(slab.fromqty),
                    ) || {};
                  const slabForCard = (product.Qtydiscounts || []).find(
                    (s) => Number(s.fromqty) === Number(item.qty),
                  ) || slab;
                  const effectiveSlab = slabForCard;
                  const discountid = effectiveSlab.discountid;
                  const fromQty = Number(effectiveSlab.fromqty);
                  const toQty = Number(effectiveSlab.toqty);
                  const pricePerItem = getFinalPrice(
                    product,
                    fromQty,
                    effectiveSlab.discount,
                  );
                  const typeLabel = getCouponTypeLabel(effectiveSlab);
                  const extraDiscount = effectiveSlab.discount;
                  const title = !isLoggedIn
                    ? `BUY ${fromQty} - ${toQty}`
                    : Number(extraDiscount) === 0
                      ? `BUY ${fromQty} - ${toQty} Get ${Number(product.discount)}% Discount`
                      : `${Number(product.discount)}% OFF + Extra ${extraDiscount}% OFF `;

                  const slabTypeMap = {
                    piece: "piece",
                    pack: "pack",
                    cart: "carton",
                    extra1: "extra1",
                    extra2: "extra2",
                    extra3: "extra3",
                  };
                  const cartPurchaseType =
                    cartQty > 0 ? activePurchaseType : null;
                  const cardType = effectiveSlab.type
                    ? slabTypeMap[effectiveSlab.type] || null
                    : null;
                  const isSelected =
                    selectedCoupon &&
                    ((selectedCoupon.discountid &&
                      Number(selectedCoupon.discountid) ===
                      Number(discountid)) ||
                      Number(selectedCoupon.fromqty || selectedCoupon.qty) ===
                      fromQty);

                  const isCardDisabled = !!(
                    (cartQty > 0 && !isSelected) ||
                    (cartPurchaseType &&
                      cardType &&
                      cardType !== cartPurchaseType)
                  );

                  return (
                    <div
                      key={index}
                      onClick={() => {
                        if (isCardDisabled) return;
                        if (isSelected) {
                          if (cartQty > 0) return;
                          setSelectedCoupon(null);
                          setSelectedPurchaseType("piece");
                          setqty(Number(product.minorderqty));
                          return;
                        }
                        const resolvedType =
                          slabTypeMap[effectiveSlab.type] || "piece";
                        setSelectedCoupon({
                          ...item,
                          qty: fromQty,
                          fromqty: fromQty,
                          toqty: toQty,
                          discount: Number(extraDiscount),
                          discountid: discountid || undefined,
                          type: effectiveSlab.type || null,
                          title,
                        });
                        setSelectedPurchaseType(resolvedType);
                        setqty(fromQty);
                      }}
                      className={`bulk-box ${isSelected ? "active" : ""} ${isCardDisabled ? "disabled" : ""}`}
                      style={{
                        borderColor: isSelected
                          ? "#005487"
                          : isCardDisabled
                            ? "#ddd"
                            : "#E0E0E0",
                        backgroundColor: isSelected ? "#F5F9FF" : "#FFFFFF",
                        opacity: isCardDisabled ? 0.5 : 1,
                        pointerEvents: isCardDisabled ? "none" : "auto",
                        cursor: isCardDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      {isSelected && (
                        <span className="bulk-applied-badge">Applied</span>
                      )}
                      <p className="bulk-title">{title}</p>

                      <div className="bulk-info">
                        {typeLabel && (
                          <span className="bulk-type"> {typeLabel}</span>
                        )}
                        {/* <span className="bulk-divider">|</span> */}
                        <span className="bulk-qty">
                          Qty: {fromQty} - {toQty}
                        </span>
                      </div>

                      <p className="bulk-price">
                        ₹{Number(pricePerItem || 0).toFixed(2)}
                        <span> Each</span>
                      </p>
                    </div>
                  );
                })}
              </div>

              <div className="cart-wishlist">
                {product.stock <= 0 ? (
                  <button
                    className="add-cart"
                    onClick={() => handleNotify(product.productid)}
                  >
                    Notify Me
                  </button>
                ) : cartQty > 0 ? (
                  <CartQuantityControl
                    qty={cartQty}
                    minQty={getQuantityStep(product)}
                    step={getQuantityStep(product)}
                    stock={product.stock}
                    purchaseType={activePurchaseType}
                    product={product}
                    onChange={handleCartQtyChange}
                    className="qty-button"
                  />
                ) : (
                  <div className="add-cart-inner">
                    <CartQuantityControl
                      qty={qty}
                      minQty={getQuantityStep(product)}
                      step={getQuantityStep(product)}
                      stock={product.stock}
                      purchaseType={selectedPurchaseType}
                      product={product}
                      onChange={(newQty) => {
                        setqty(Number(newQty));
                      }}
                      className="qty-button"
                    />
                    <button
                      className="add-cart"
                      onClick={() => handleAddToCart(product.productid)}
                    >
                      Add To Cart
                    </button>
                  </div>
                )}

                <button
                  className="wishlist-btn1"
                  onClick={() => AddToWishList(product.productid)}
                  disabled={wishlistItems.includes(product.productid)}
                >
                  {wishlistItems.includes(product.productid)
                    ? "Wishlist"
                    : " Wishlist"}
                </button>
              </div>

              {/* {product.stock > 0 && (
                <button
                  className="buy-now"
                  onClick={() => handleAddToCart(product.productid)}
                >
                  Buy Now
                </button>
              )} */}

              <div className="features-row">
                <PincodeChecker />
              </div>
              <div className="features">
                {/* <p>
                  <MdLocalShipping
                    style={{
                      fontSize: "18px", 
                      color: "#005487",
                      transform: "scaleX(-1)",  
                    }}
                  />{" "}
                  Free shipping on all orders over ₹1000
                </p> */}
                <p>
                  <FaRegClock style={{ fontSize: "23px", color: "#005487" }} />{" "}
                  Delivers in 3–7 Working Days
                </p>
              </div>
              {/* <Coupons
                showPreview
                onOpen={() => setOpenCoupons(true)}
                activePurchaseType={activePurchaseType}
              />

              <Coupons
                isModalOpen={openCoupons}
                onClose={() => setOpenCoupons(false)}
                activePurchaseType={activePurchaseType}
              /> */}
            </div>
          </div>
        </div>
        {/* REVIEWS */}
        <div>
          {" "}
          {ratings.length > 0 && (
            <div
              className="reviews-section"
            >
              <h3 style={{ marginBottom: 15 }}>Customer Reviews</h3>

              {/* Scroll Buttons */}
              <div className="review-scroll-wrapper">
                {/* Left Button */}
                <button
                  onClick={() => {
                    document.getElementById("review-scroll").scrollLeft -= 300;
                  }}
                  className="review-arrow-left"
                >
                  <IoIosArrowBack color="black" />
                </button>

                {/* Right Button */}
                <button
                  onClick={() => {
                    document.getElementById("review-scroll").scrollLeft += 300;
                  }}
                  className="review-arrow-right"
                >
                  <IoIosArrowForward color="black" />
                </button>
              </div>

              {/* Review Cards */}
              <div
                id="review-scroll"
                className="review-cards-scroll"
              >
                {comments?.map((item) => (
                  <div
                    key={item.cid}
                    className="review-card"
                  >
                    <Rate allowHalf disabled value={item.rating || 0} />

                    {item.name && (
                      <p
                        style={{
                          marginTop: "10px",
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#222",
                          wordBreak: "break-word",
                        }}
                      >
                        {item.name}
                      </p>
                    )}

                    <p
                      style={{
                        marginTop: "8px",
                        color: "#555",
                        fontSize: "13px",
                        lineHeight: "20px",
                        wordBreak: "break-word",
                      }}
                    >
                      {item.comment}
                    </p>

                    <p
                      style={{
                        marginTop: "8px",
                        fontSize: "12px",
                        color: "#888",
                      }}
                    >
                      {item.givendate}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Product Spares Component */}
        <ProductSpares
          key={productid}
          productId={productid}
          navigate={navigate}
          onProductClick={scrollToProductTop}
        />

        {/* Similar Products Component */}
        <SimilarProducts
          productId={productid}
          navigate={navigate}
          onProductClick={scrollToProductTop}
        />
        {/* Specifications */}

        <AddRecentlyViewed productid={product.productid} />

        {showAuthModal && (
          <AuthModal
            initialMode="login"
            onClose={() => setShowAuthModal(false)}
            onSuccess={handleAuthSuccess}
          />
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: "white",
    padding: "20px",
    borderRadius: "8px",
  },
};

export default ProductPage;
